export default "__VITE_ASSET__DQU1hanc__"